<app-navbar [address]="address" (GetCountryId)="getCountryId($event)"></app-navbar>

<section class="section-padding contact-top bg-light-theme">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-header-left">
                    <h3 class="text-light-black header-title">{{'BatchOrders' | translate}}</h3>
                </div>

                <!-- Batch Configuration -->
                <div class="checkout-card mb-4">
                    <h4 class="text-warning text-style-right">{{'BatchConfiguration' | translate}}</h4>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>{{'NumberOfOrders' | translate}} *</label>
                                <input type="number" class="form-control" [(ngModel)]="orderCount" (change)="onOrderCountChange()" min="2" max="100">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Service Type Selection -->
                <div class="d-flex justify-content-center mb-4">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn" [class.btn-primary]="serviceType === 'send'" (click)="setServiceType('send')">{{'Send' | translate}}</button>
                        <button type="button" class="btn" [class.btn-primary]="serviceType === 'receive'" (click)="setServiceType('receive')">{{'Receive' | translate}}</button>
                    </div>
                </div>

                <form [formGroup]="batchOrderForm" (ngSubmit)="onSubmit()">
                    <!-- Sender Information -->
                    <div class="checkout-card mb-4">
                        <h4 class="text-warning text-style-right">{{'SenderInformationForAllOrders' | translate}}</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Sender Name' | translate}} *</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderName')" formControlName="senderName">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderName')">
                                        {{getErrorMessage('senderName') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Phone' | translate}} *</label>
                                    <mat-form-field appearance="fill" class="w-100">
                                        <ngx-mat-intl-tel-input 
                                            formControlName="senderPhone" 
                                            [enablePlaceholder]="true"
                                            [preferredCountries]="['kw', 'jo']" 
                                            [enableSearch]="true"
                                            searchPlaceholder="{{'Search country' | translate}}" 
                                            [cssClass]="'custom form-control'">
                                        </ngx-mat-intl-tel-input>
                                    </mat-form-field>
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderPhone')">
                                        {{getErrorMessage('senderPhone') | translate}}
                                    </div>
                                    <!-- <mat-error *ngIf="(batchOrderForm.get('senderPhone').dirty) && batchOrderForm.get('senderPhone').errors && batchOrderForm.get('senderPhone').errors.invalidPhoneNumber">
                                        {{'PhoneNumberNotValid' | translate}}
                                    </mat-error> -->
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'SenderLocation' | translate}} *</label>
                                    <div class="location-wrapper">
                                        <div class="input-group">
                                            <input type="text" class="form-control" formControlName="senderAddress" readonly>
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-primary" (click)="openMap('sender')">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </button>
                                                <button type="button" class="btn btn-success" (click)="fillCurrentLocation('sender')" title="{{'Use Current Location' | translate}}">
                                                    <i class="fas fa-crosshairs"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('senderAddress')">
                                            {{'ThisFieldRequired' | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'City' | translate}} *</label>
                                    <input type="text" class="form-control" formControlName="senderCity" [class.is-invalid]="isFieldInvalid('senderCity')">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderCity')">
                                        {{getErrorMessage('senderCity') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Region/Area' | translate}} *</label>
                                    <input type="text" class="form-control" formControlName="senderRegion" [class.is-invalid]="isFieldInvalid('senderRegion')">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderRegion')">
                                        {{getErrorMessage('senderRegion') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Street' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="senderStreet">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Building No.' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="senderBuildingNo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Apartment No.' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="senderApartmentNo">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Dynamic Order Forms -->
                    <div formArrayName="orders" class="orders-container">
                        <!-- Order Progress -->
                        <div class="order-progress mb-4">
                            <div class="progress-steps">
                                <ng-container *ngFor="let order of orders.controls; let i=index">
                                    <div class="step" [class.active]="order.get('isActive').value">
                                        <div class="step-circle">
                                            <span class="step-number">{{i + 1}}</span>
                                            <i class="fas" [class.fa-check]="isOrderValid(i)" 
                                               [class.fa-exclamation]="!isOrderValid(i)"
                                               [class.text-success]="isOrderValid(i)"
                                               [class.text-warning]="!isOrderValid(i)"></i>
                                        </div>
                                        <div class="step-label">
                                            {{'Order' | translate}} {{i + 1}}
                                        </div>
                                    </div>
                                    <div class="step-connector" *ngIf="i < orders.length - 1"></div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Order Content -->
                        <div class="orders-content">
                            <div class="order-panel" [class.active]="getCurrentOrderIndex() === i" *ngFor="let order of orders.controls; let i=index" [formGroupName]="i">
                                <!-- Order Header -->
                                <div class="order-header">
                                    <h4 class="mb-0">
                                        <span class="badge" [class.badge-primary]="getCurrentOrderIndex() === i" 
                                              [class.badge-light]="getCurrentOrderIndex() !== i">
                                            {{'Order' | translate}} {{i + 1}}
                                        </span>
                                    </h4>
                                    <div class="order-status">
                                        <span class="status-badge" [class.valid]="isOrderValid(i)" [class.invalid]="!isOrderValid(i)">
                                            {{ isOrderValid(i) ? ('Complete' | translate) : ('Incomplete' | translate) }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Receiver Information -->
                                <div class="form-section">
                                    <h5 class="section-title text-warning text-style-right">{{'ReceiverInformation' | translate}}</h5>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'ReceiverName' | translate}} *</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverName" 
                                                       [class.is-invalid]="isFieldOrderInvalid('receiverName', i)">
                                                <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('receiverName', i)">
                                                    {{'ThisFieldRequired' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'Phone' | translate}} *</label>
                                                <mat-form-field appearance="outline" class="w-100">
                                                    <ngx-mat-intl-tel-input 
                                                        formControlName="receiverPhone" 
                                                        [enablePlaceholder]="true"
                                                        [preferredCountries]="['kw', 'jo']" 
                                                        [enableSearch]="true"
                                                        searchPlaceholder="{{'SearchCountry' | translate}}" 
                                                        [cssClass]="'custom-tel-input'">
                                                    </ngx-mat-intl-tel-input>
                                                </mat-form-field>
                                                <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('receiverPhone', i)">
                                                    {{'PhoneNumberNotValid' | translate}}
                                                </div>
                                                <!-- <mat-error *ngIf="(order.get('receiverPhone').dirty) && order.get('receiverPhone').errors && order.get('receiverPhone').errors.invalidPhoneNumber">
                                                    {{'PhoneNumberNotValid' | translate}}
                                                </mat-error> -->
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'ReceiverLocation' | translate}} *</label>
                                                <div class="location-wrapper">
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" formControlName="receiverAddress" readonly>
                                                        <div class="input-group-append">
                                                            <button type="button" class="btn btn-primary" (click)="openMap('receiver', i)">
                                                                <i class="fas fa-map-marker-alt"></i>
                                                            </button>
                                                            <button type="button" class="btn btn-success" (click)="fillCurrentLocation('receiver', i)" title="{{'Use Current Location' | translate}}">
                                                                <i class="fas fa-crosshairs"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('receiverAddress', i)">
                                                        {{'ThisFieldRequired' | translate}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'City' | translate}} *</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverCity" 
                                                       [class.is-invalid]="isFieldOrderInvalid('receiverCity', i)">
                                                <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('receiverCity', i)">
                                                    {{'ThisFieldRequired' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'RegionArea' | translate}} *</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverRegion" 
                                                       [class.is-invalid]="isFieldOrderInvalid('receiverRegion', i)">
                                                <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('receiverRegion', i)">
                                                    {{'ThisFieldRequired' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'Street' | translate}}</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverStreet">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'BuildingNo' | translate}}</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverBuildingNo">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'ApartmentNo' | translate}}</label>
                                                <input type="text" class="form-control custom-input" formControlName="receiverApartmentNo">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Package Details -->
                                <div class="form-section">
                                    <h5 class="section-title text-warning text-style-right">{{'PackageDetails' | translate}}</h5>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'PackageType' | translate}} *</label>
                                                <input type="text" class="form-control custom-input" formControlName="packageType" 
                                                       placeholder="{{'PackageTypeExample' | translate}}"
                                                       [class.is-invalid]="isFieldOrderInvalid('packageType', i)">
                                                <div class="invalid-feedback" *ngIf="isFieldOrderInvalid('packageType', i)">
                                                    {{'ThisFieldRequired' | translate}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'PackageDescription' | translate}}</label>
                                                <textarea class="form-control custom-input" formControlName="packageDescription" rows="3"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{'PackageWeight' | translate}}</label>
                                                <input type="number" class="form-control custom-input" formControlName="packageWeight">
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'Notes' | translate}}</label>
                                                <textarea class="form-control custom-input" formControlName="notes" rows="2"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>{{'PackageImages' | translate}} ({{'Optional' | translate}})</label>
                                                <div class="custom-file">
                                                    <input type="file" class="custom-file-input" [id]="'packageImages' + i" 
                                                           (change)="onFileSelected($event, i)" multiple accept="image/*">
                                                    <label class="custom-file-label custom-input" [for]="'packageImages' + i"  [class.custom-file-label-right]="current_lang === 'ar'">
                                                        {{'ChooseFiles' | translate}}
                                                    </label>
                                                </div>
                                                <div class="selected-images mt-3" *ngIf="getSelectedImages(i).length > 0">
                                                    <div class="row">
                                                        <div class="col-md-3 col-6 mb-3" *ngFor="let image of getSelectedImages(i); let imgIndex = index">
                                                            <div class="image-preview-container">
                                                                <img [src]="image" class="img-thumbnail">
                                                                <button type="button" class="btn btn-remove" 
                                                                        (click)="removeImage(i, imgIndex)">
                                                                    <i class="fas fa-times"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Navigation Buttons -->
                        <div class="order-navigation">
                            <button type="button" class="btn btn-nav" 
                                    (click)="navigateOrder(getCurrentOrderIndex() - 1)" 
                                    [disabled]="isFirstOrder()">
                                <i class="fas fa-chevron-left"></i> {{'Previous' | translate}}
                            </button>
                            <div class="order-progress-text">
                                {{ getCurrentOrderIndex() + 1 }} / {{ orders.length }}
                            </div>
                            <button type="button" class="btn btn-nav" 
                                    (click)="navigateOrder(getCurrentOrderIndex() + 1)"
                                    [disabled]="isLastOrder()">
                                {{'Next' | translate}} <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Common Settings -->
                    <div class="checkout-card mb-4">
                        <h4 class="text-warning text-style-right">{{'CommonSettings' | translate}}</h4>
                        
                        <!-- Vehicle Size -->
                        <div class="form-group">
                            <label>{{'Vehicle Size' | translate}}</label>
                            <div class="row">
                                <div class="col-md-4" *ngFor="let size of vehicleSizes">
                                    <div class="card vehicle-size-card" 
                                         [class.selected]="batchOrderForm.get('deliveryCarSizeId').value === size.id"
                                         (click)="selectVehicleSize(size.id)">
                                        <div class="card-body text-center">
                                            <img [src]="size.iconUrl ? size.iconUrl : '/assets/img/delivery_car.jpg'" [alt]="size.name" class="mb-2" width="50" height="50">
                                            <h6>{{size.name}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="alert alert-warning mt-2 text-style-right" [class.text-right]="current_lang === 'ar'">
                                <i class="fas fa-exclamation-triangle mr-2"></i>
                                {{'The choice of vehicle size is at the customer\'s own risk.' | translate}}
                            </div>
                            <div *ngIf="deliveryPrice !== null" class="alert alert-info mt-2 text-style-right" [class.text-right]="current_lang === 'ar'">
                                <i class="fas fa-info-circle mr-2"></i>
                                <strong>{{'Estimated Delivery Price:' | translate}}</strong> {{deliveryPrice | currency:
                settingService.getCurrencySymbol()}}
                            </div>
                        </div>

                        <!-- Batch Notes -->
                        <div class="form-group">
                            <label>{{'BatchNotes' | translate}}</label>
                            <textarea class="form-control" formControlName="batchNotes" rows="3"></textarea>
                        </div>

                        <!-- Payment Method -->
                        <div class="form-group">
                            <a href="javascript:void(0)" data-toggle="modal" data-target="#paymentMethodsModal">
                                <div class="checkout-card2">
                                    <div class="d-flex">
                                        <div class="p-2">
                                            <span class="fa fa-credit-card"></span>
                                        </div>
                                        <div class="p-2 d-flex flex-column">
                                            <h5>{{'Pay With' | translate}}</h5>
                                            <span>{{paymentMethodText | translate}}</span>
                                        </div>
                                        <div [ngClass]="current_lang == 'en' ? 'ml-auto' : 'mr-auto'" class="p-2">
                                            <span class="text-danger fa fa-exclamation-triangle"></span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary btn-lg" [disabled]="batchOrderForm.invalid || isSubmitting">
                            {{'PlaceBatchOrder' | translate}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<app-footer2 id="footer"></app-footer2>

<!-- Payment Methods Modal -->
<div class="modal fade" id="paymentMethodsModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-left">{{'Payment methods' | translate}}</h4>
                <button type="button" class="close text-right" data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ng-container *ngFor="let method of getPaymentMethodKeys(); let i = index">
                    <ng-container *ngIf="isApple">
                        <div (click)="toggleModal(paymentMethodIcons[method].numericValue,paymentMethodIcons[method].text)" class="d-flex mb-2 checkout-card2">
                            <div class="p-2">
                                <img class="payment-image" [src]="paymentMethodIcons[method].iconClass" alt="{{ method }} Image">
                            </div>
                            <div class="p-2 d-flex flex-column">
                                <h5>{{ method | translate }}</h5>
                            </div>
                            <div *ngIf="paymentNumber === paymentMethodIcons[method].numericValue" class="p-2 ml-auto">
                                <span class="text-danger fa fa-check"></span>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!isApple">
                        <div *ngIf="paymentMethodIcons[method].numericValue != 2" (click)="toggleModal(paymentMethodIcons[method].numericValue,paymentMethodIcons[method].text)" class="d-flex mb-2 checkout-card2">
                            <div class="p-2">
                                <img class="payment-image" width="70" [src]="paymentMethodIcons[method].iconClass" alt="{{ method }} Image">
                            </div>
                            <div class="p-2 d-flex flex-column">
                                <h5>{{ method | translate }}</h5>
                            </div>
                            <div *ngIf="paymentNumber === paymentMethodIcons[method].numericValue" class="p-2 ml-auto">
                                <span class="text-danger fa fa-check"></span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <hr>
                <button (click)="closeModal()" type="button" class="btn done-btn pt-1 pb-2 w-100">
                    <span>{{'Done' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Map Container -->
<div #mapContainer id="mapContainer" class="map-modal">
    <div class="map-modal-header">
        <h5 class="mb-0">{{'Select Location' | translate}}</h5>
        <button type="button" class="btn btn-sm btn-close" (click)="closeMap()">
            <i class="fas fa-times"></i>
        </button>
    </div>
    <div class="map-modal-content">
        <div class="map-search">
            <div class="input-group">
                <input #searchInput type="text" class="form-control location-search-input" 
                       placeholder="{{'SearchForLocation' | translate}}">
                <div class="input-group-append">
                    <button class="btn btn-primary" (click)="searchLocation()">
                        <i class="fas fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="map-view"></div>
        <div class="map-instructions text-center mt-2">
            <small class="text-muted">
                {{'Click on the map or drag the marker to select location' | translate}}
            </small>
        </div>
        <div class="map-modal-footer">
            <div class="d-flex justify-content-between align-items-center">
                <button type="button" class="btn btn-secondary" (click)="closeMap()">
                    <i class="fas fa-times"></i> {{'Cancel' | translate}}
                </button>
                <button type="button" class="btn btn-success" (click)="confirmLocation()">
                    <i class="fas fa-check"></i> {{'ConfirmSelectedLocation' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
